export default {
  data() {
    return {}
  },
  created() {
    localStorage.setItem("ladingPageId", this.$route.query.ladingPageId || 0)
  },
}